import { fetchRFPData } from "../../RFPBuilder/services/fetchRFPData";
import  exportRFPasDOCX  from "../../RFPBuilder/utilities/exportRFPasDocx";

export const handleViewRFP = async (rfpId, rfpOwnerId) => {
const rfpOwner = {_id: rfpOwnerId}
const rfpData = await fetchRFPData(rfpOwner, rfpId)
exportRFPasDOCX(rfpData.rfp.documentData)
}